import { useState } from "react";
import { useLocalization } from "@fluent/react";
import { Chip, Popover } from "@narmi/design_system";
import styles from "./RecentTransactionsModule.module.scss";

const MONEY_IN_OUT_OPTIONS = ["in", "out"] as const;

interface TransactionTypeFilterChipProps {
  value: "in" | "out" | null;
  onApply: (value: "in" | "out" | null) => void;
}

const TransactionTypeFilterChip = ({
  value,
  onApply,
}: TransactionTypeFilterChipProps) => {
  const { l10n } = useLocalization();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      isOpen={isOpen}
      onUserDismiss={() => setIsOpen(false)}
      content={
        <div className={styles.searchPopover}>
          <ul className={styles.accountList}>
            {MONEY_IN_OUT_OPTIONS.map((option) => (
              <li key={option}>
                <button
                  type="button"
                  className={`${styles.recentSearchItem} button--reset`}
                  onClick={() => {
                    onApply(value === option ? null : option);
                    setIsOpen(false);
                  }}
                >
                  <span className={styles.transactionTypeOption}>
                    {option === "in"
                      ? l10n.getString("recent-transactions-filter-money-in")
                      : l10n.getString("recent-transactions-filter-money-out")}
                    {value === option && (
                      <span className="narmi-icon-check" aria-hidden="true" />
                    )}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      }
    >
      <Chip
        label={l10n.getString("recent-transactions-filter-transaction-type")}
        kind={value !== null ? "primary" : "secondary"}
        endIcon={isOpen ? "chevron-up" : "chevron-down"}
        onClick={() => setIsOpen((prev) => !prev)}
      />
    </Popover>
  );
};

export default TransactionTypeFilterChip;
